import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Confidencialidad from '../images/confidencialidad.svg';
import Eficiencia from '../images/eficiencia.svg';
import Cliente from '../images/cliente.svg';
import Vision from '../images/vision.svg';
import '../styles/DespachosJuridicos.css';
import '../styles/CustomSlider.css';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from "react";
import Abogado1 from '../images/abogado1.png';
import Abogado2 from '../images/abogado2.png';
import Abogado3 from '../images/abogado3.png';

export function DespachosJuridicosPage() {
    const [formData, setFormData] = useState({
        nombre: '',
        correo: '',
        asunto: '',
        mensaje: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const btn = document.querySelector(".amplify-button--primary");
        if (btn) btn.click();
    }, []);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        try {
            console.log('Enviando datos:', formData);
            
            // Proxy CORS temporal - reemplazar con API Gateway cuando CORS esté configurado
            const response = await fetch('https://y2o0kcyxa0.execute-api.us-east-1.amazonaws.com/dev/contact', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    correo: formData.correo,
                    nombre: formData.nombre,
                    asunto: formData.asunto,
                    mensaje: formData.mensaje
                })
            });
            
            console.log('Response status:', response.status);
            
            if (response.ok) {
                const result = await response.json();
                console.log('Success:', result);
                alert('Mensaje enviado exitosamente');
                setFormData({ nombre: '', correo: '', asunto: '', mensaje: '' });
            } else {
                const errorData = await response.text();
                console.error('Error response:', errorData);
                throw new Error(`Error ${response.status}: ${errorData}`);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            if (error.name === 'TypeError' && error.message.includes('fetch')) {
                alert('Error de conexión: Verifica que la API Gateway esté configurada correctamente y tenga CORS habilitado');
            } else {
                alert('Error: ' + error.message);
            }
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <Box className="box-service">
            <Grid container spacing={2}>

                <Grid size={12} className="section-despachos">
                    <Grid size={12} className="section1-despachos">
                        <h1>¡CUÉNTANOS TU CASO!</h1>
                    </Grid>
                </Grid>

                <Grid size={12} className="section3-despachos">
                    <p>¿Necesitas ayuda con otro asunto?
                        ¡Escríbenos! </p>
                    <Grid size={12}
                        mt={5}
                        direction="column"
                        alignItems="center"
                        style={{ textAlign: "center" }}>
                        <Box
                            mt={7}
                            component="form"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 5,
                            }}
                            className='box-form'
                        >
                            <TextField 
                                name="nombre"
                                label="Full Name" 
                                variant="outlined" 
                                className="textField" 
                                fullWidth 
                                sx={{ maxWidth: '800px' }}
                                value={formData.nombre}
                                onChange={handleInputChange}
                                required
                            />
                            <TextField 
                                name="correo"
                                label="Email Address" 
                                variant="outlined" 
                                className="textField" 
                                fullWidth 
                                sx={{ maxWidth: '800px' }}
                                value={formData.correo}
                                onChange={handleInputChange}
                                type="email"
                                required
                            />
                            <TextField 
                                name="asunto"
                                label="Subject" 
                                variant="outlined" 
                                className="textField" 
                                fullWidth 
                                sx={{ maxWidth: '800px' }}
                                value={formData.asunto}
                                onChange={handleInputChange}
                                required
                            />
                            <TextField 
                                name="mensaje"
                                label="Your Message" 
                                variant="outlined" 
                                multiline 
                                rows={4} 
                                className="textField" 
                                fullWidth 
                                sx={{ maxWidth: '800px' }}
                                value={formData.mensaje}
                                onChange={handleInputChange}
                                required
                            />

                            <button 
                                type="submit"
                                className='button-send-despachos'
                                onClick={handleSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Enviando...' : 'Enviar'}
                            </button>
                        </Box>
                    </Grid>

                </Grid>

{/* 
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 0 20px 0', width: '100%' }} className='directorio-abogados'>
                    <h2 style={{ fontSize: '36px', color: '#0A2342', margin: 0, textAlign: 'center' }}>Directorio de Abogados y Firmas Legales</h2>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Grid container spacing={4} sx={{ padding: '40px 20px', justifyContent: 'center', maxWidth: '1200px' }}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{
                            backgroundColor: 'white',
                            borderRadius: '15px',
                            padding: '20px',
                            textAlign: 'center',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                        }}>
                            <img src={Abogado1} alt="Abogado 1" style={{ width: '80px', height: '80px', borderRadius: '50%', marginBottom: '15px' }} />
                            <h3 style={{ margin: '10px 0 5px 0', fontSize: '20px' }}>Juan Pérez</h3>
                            <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>Derecho Penal</p>
                            <div style={{ margin: '10px 0' }}><span style={{ color: '#FFD700' }}>★★★★☆</span> <span style={{ color: 'black' }}>(4.0)</span></div>
                            <p style={{ margin: '15px 0', fontSize: '14px', lineHeight: '1.4' }}>"Excelente profesional, muy dedicado y con gran conocimiento en la materia."</p>
                            <button style={{
                                backgroundColor: '#B8860B',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontWeight: 'bold'
                            }}>Contactar</button>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{
                            backgroundColor: 'white',
                            borderRadius: '15px',
                            padding: '20px',
                            textAlign: 'center',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                        }}>
                            <img src={Abogado2} alt="Abogado 2" style={{ width: '80px', height: '80px', borderRadius: '50%', marginBottom: '15px' }} />
                            <h3 style={{ margin: '10px 0 5px 0', fontSize: '20px' }}>García & Asociados</h3>
                            <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>Derecho Corporativo</p>
                            <div style={{ margin: '10px 0' }}><span style={{ color: '#FFD700' }}>★★★★★</span> <span style={{ color: 'black' }}>(5.0)</span></div>
                            <p style={{ margin: '15px 0', fontSize: '14px', lineHeight: '1.4' }}>"Una firma muy prestigiosa con un equipo de abogados de primer nivel."</p>
                            <button style={{
                                backgroundColor: '#B8860B',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontWeight: 'bold'
                            }}>Contactar</button>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{
                            backgroundColor: 'white',
                            borderRadius: '15px',
                            padding: '20px',
                            textAlign: 'center',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                        }}>
                            <img src={Abogado3} alt="Abogado 3" style={{ width: '80px', height: '80px', borderRadius: '50%', marginBottom: '15px' }} />
                            <h3 style={{ margin: '10px 0 5px 0', fontSize: '20px' }}>María Rodríguez</h3>
                            <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>Derecho de Familia</p>
                            <div style={{ margin: '10px 0' }}><span style={{ color: '#FFD700' }}>★★★★☆</span> <span style={{ color: 'black' }}>(4.0)</span></div>
                            <p style={{ margin: '15px 0', fontSize: '14px', lineHeight: '1.4' }}>"Me ayudó a resolver mi caso de divorcio de manera rápida y eficiente."</p>
                            <button style={{
                                backgroundColor: '#B8860B',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontWeight: 'bold'
                            }}>Contactar</button>
                        </Box>
                    </Grid>
                    </Grid>
                </div>
*/}

            </Grid>
        </Box>
    );
}

